<template>
  <b-input-group class="assign-select">

    <multiselect
        ref="multiselect"
        :options="workPlans"
        label="label"
        track-by="workPlanId"
        v-model="selected"
        selectLabel=""
        placeholder="Select plan"
        :disabled="disabled"
        :maxHeight="200"
    >
      <template slot="caret">
        <caret-icon></caret-icon>
      </template>
    </multiselect>
    <b-input-group-append v-if="confirmButtons && allowed" class="transparent">
      <b-btn
          v-if="disabled"
          @click="disabled = false"
      >
        <font-awesome-icon
            :icon="['far', 'pencil']"
            size="sm"
        >
        </font-awesome-icon>
      </b-btn>
      <b-btn
          v-if="!disabled && !loading"
          @click="onConfirm"
      >
        <font-awesome-icon
            :icon="['fal', 'check']"
            class="green"
            size="sm"
        >
        </font-awesome-icon>
      </b-btn>
      <b-btn
          v-if="!disabled && !loading"
          @click="onCancel"
      >
        <font-awesome-icon
            :icon="['far', 'times']"
            class="red"
            size="sm"
        >
        </font-awesome-icon>
      </b-btn>
      <b-btn
          v-if="loading"
      >
        <font-awesome-icon
            :icon="['fal', 'spinner']"
            size="sm"
            spin
        >
        </font-awesome-icon>
      </b-btn>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'Work-Plan-Select',
  props: {
    options: {},
    value: {},
    confirmButtons: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      allowed: false,
      disabled: false,
      selected: null,
      originalSelected: null,
      workPlans: [],
    };
  },

  watch: {
    selected: {
      handler(newSelected) {
        if (!this.confirmButtons) {
          this.$emit('input', newSelected);
        }
      },
      immediate: true,
      deep: true,
    },
    options(newOptions) {
      this.workPlans = newOptions;
    },
    confirmButtons: {
      handler(newConfirmButtons) {
        this.allowed = newConfirmButtons;
      },
      immediate: true,
    },
  },

  mounted() {
    this.$refs.multiselect.activate();

    this.workPlans = this.options;

    if (this.confirmButtons) {
      this.disabled = true;
    }
  },

  methods: {
    onCancel() {
      this.selected = this.originalSelected;
      this.disable();
    },
    onConfirm() {
      this.$emit('input', this.selected);
      this.$emit('confirm', this.selected);
    },
    disable() {
      this.disabled = true;
    },
    onInput(value) {
      if (!this.confirmButtons && !this.disabled) {
        this.$emit('input', value);
      }
    },
  },
};
</script>

<style lang="scss">
.assign-select {
  .multiselect__option {
    padding-left: 25px;

    &--disabled {
      padding-left: 10px;
    }
  }
}
.form-control::placeholder {
  color: #adadad;
}
.multiselect__option span {
  white-space: normal !important;
  line-height: 1.5;
}
</style>
